module.exports = __webpack_public_path__ + "static/img/3.b51d4d3d.png";